import React from 'react';

import DefaultRedux from '../../redux/defaultRedux';
import Config from '../../shared/config/Configuration';
import Scrollable from '../../shared/tools/Scrollable';
import MenuBar from './menuBar/MenuBar';

import LogoSvg from '../../assets/LogoStairs.svg';

import styles from './Navigation.module.scss';


class Navigation extends React.Component {
  onClickMenuButton = () => {
    this.props.rd.onShowMenu(!this.props.rs.showMenu);
  };

  onClickCompanyName = () => {
    Scrollable.scrollTo('top');
  };

  render() {
    const menuButtonStyle = [styles.MenuButton];

    if (this.props.rs.showMenu) {
      menuButtonStyle.push(styles.MenuButtonOpened);
    }

    return (
      <React.Fragment>
        <nav>
          <div className={styles.Contact}>
            <div className={styles.ContactInfoTel}>
              <b>tel:</b> <a href={`tel:${Config.tel.num}`}>{Config.tel.text}</a>
            </div>
            {Config.email && (
              <div className={styles.ContactInfoEmail}>
                <b>email:</b> <a href={`email:${Config.email}`}>{Config.email}</a>
              </div>
            )}
          </div>
          <div className={styles.CompanyTitle}>
            <img alt='' src={LogoSvg}/>
            <div className={styles.CompanyName} onClick={this.onClickCompanyName}>{Config.companyName}</div>
          </div>
          <div className={menuButtonStyle.join(' ')} onClick={this.onClickMenuButton}>
            <div className={`${styles.Line} ${styles.Line1}`}/>
            <div className={`${styles.Line} ${styles.Line2}`}/>
            <div className={`${styles.Line} ${styles.Line3}`}/>
          </div>
        </nav>
        <MenuBar/>
      </React.Fragment>
    );
  }
}

Navigation = DefaultRedux.connect(Navigation);

export default Navigation;
